import { useTranslation as useI18nTranslation } from "react-i18next";

/**
 * Enhanced translation hook with additional utilities
 * Use this instead of react-i18next's useTranslation for better functionality
 */
export const useTranslation = () => {
  const { t, i18n, ready } = useI18nTranslation();

  /**
   * Get translation
   * @param key - Translation key
   * @param options - i18next options
   */
  const translate = (key: string, options?: any): string => {
    const translation = t(key, options);
    // Ensure we always return a string
    return typeof translation === "string" ? translation : String(translation);
  };

  /**
   * Check if translation exists
   */
  const hasTranslation = (key: string): boolean => {
    return t(key) !== key;
  };

  /**
   * Get current language
   */
  const currentLanguage = i18n.language;

  /**
   * Check if current language is Hebrew
   */
  const isHebrew = currentLanguage === "he";

  /**
   * Check if current language is English
   */
  const isEnglish = currentLanguage === "en";

  /**
   * Change language and update document direction
   */
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    document.documentElement.setAttribute("dir", lng === "he" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lng);
  };

  return {
    t: translate,
    translate,
    i18n,
    ready,
    currentLanguage,
    isHebrew,
    isEnglish,
    changeLanguage,
    hasTranslation,
  };
};
